import 'twin.macro'

import { CheckIcon } from 'assets/icons/CheckIcon'
import UserIconWithoutFill from 'assets/icons/UserIconWithoutFill'
import BodyText from 'components/UI/body-text/body-text'
import { Button } from 'components/UI/button/button'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import { ThemeContext } from 'contexts/theme-context'
import React, { useContext, useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import LandingBuyCardContainer from '../landing-buy-card-container'
import GreenGradient from './../../../assets/images/benefits-container-5-green-gradient.webp'
import Envelope from './../../../assets/images/envelope-img.webp'
import EnvelopeDark from './../../../assets/images/envelope-img-dark.webp'

function GiftCard() {
  const { t } = useTranslation()

  const { theme } = useContext(ThemeContext)
  const steps = useMemo(
    () => [
      t('gift_card.container_2.step_1', { ns: 'landing' }),
      t('gift_card.container_2.step_2', { ns: 'landing' }),
      t('gift_card.container_2.step_3', { ns: 'landing' }),
      t('gift_card.container_2.step_4', { ns: 'landing' })
    ],
    [t]
  )

  return (
    <>
      <div>
        <p tw='sm:text-[48px] text-[32px] font-bold'>{t('gift_card.title', { ns: 'landing' })}</p>
        <div tw='flex sm:flex-row flex-col mt-5 gap-8'>
          <LandingBuyCardContainer />
          <div tw='bg-secondary rounded-s32 p-[32px]  relative gap-2 overflow-hidden w-full flex flex-col gap-5 sm:max-w-[395px]'>
            <Title variant='bold'>
              <Trans>{t('gift_card.container_2.title', { ns: 'landing' })}</Trans>
            </Title>
            <div
              tw='flex flex-col gap-5'
              css={theme === 'dark' ? tw`text-[rgba(209, 209, 214, 1)]` : tw`text-[#636366]`}
            >
              {steps.map((item, idx) => (
                <div tw='flex gap-4 font-semibold items-center' key={`step-${idx + 1}`}>
                  <div
                    tw='min-w-[32px] min-h-[32px] max-h-[32px] rounded-full bg-primary font-bold flex items-center justify-center'
                    className={idx === 3 ? 'gradiented-color' : ''}
                  >
                    {idx === 3 ? <CheckIcon tw='text-white' /> : idx + 1}
                  </div>
                  {item}
                </div>
              ))}
            </div>
            <img src={GreenGradient} alt='' tw='rotate-[90deg] -left-10 absolute bottom-0' />
          </div>
        </div>
        <div tw='bg-secondary rounded-s32 p-[32px]  relative gap-2 overflow-hidden w-full flex flex-col gap-5 mt-8 sm:min-h-0 min-h-[296px]'>
          <div tw='flex sm:flex-row flex-col sm:items-center gap-4'>
            <div
              css={theme === 'dark' ? tw`bg-[rgba(255, 255, 255, 0.1)]` : tw`bg-[rgba(0, 0, 0, 0.1)]`}
              tw='w-[32px] h-[32px] max-h-[32px] rounded-full font-bold text-secondary flex items-center justify-center'
            >
              <UserIconWithoutFill />
            </div>
            <BodyText twStyle={tw`font-medium`}>
              <Trans>{t('gift_card.container_3', { ns: 'landing' })}</Trans>{' '}
            </BodyText>
          </div>
          <img src={theme === 'dark' ? EnvelopeDark : Envelope} alt='' width={206} tw='absolute bottom-0 right-10' />
          <img src={GreenGradient} alt='' tw=' right-0 absolute -bottom-40' />
        </div>
      </div>
    </>
  )
}

export default GiftCard
